// extracted by mini-css-extract-plugin
module.exports = {"canvas":"foodCanvas_canvas__3BMP1"};